// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__25geN","title":"ClientReferral_title__2350M","itemText":"ClientReferral_itemText__1-LGk"};